var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',{class:_vm.classes,attrs:{"length":_vm.pagination.pageCount,"total-visible":_vm.totalVisible},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})}
var staticRenderFns = []

export { render, staticRenderFns }